function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17 12.5c-1.2 0-2.4-.2-3.6-.6-.3-.1-.7 0-1 .2l-2.2 2.2c-2.8-1.4-5.1-3.8-6.6-6.6l2.2-2.2c.3-.3.4-.7.2-1-.3-1.1-.5-2.3-.5-3.5 0-.6-.4-1-1-1H1C.4 0 0 .4 0 1c0 9.4 7.6 17 17 17 .6 0 1-.4 1-1v-3.5c0-.6-.4-1-1-1zM16 9h2c0-5-4-9-9-9v2c3.9 0 7 3.1 7 7zm-4 0h2c0-2.8-2.2-5-5-5v2c1.7 0 3 1.3 3 3z",
  fill: "#FFF",
  fillRule: "evenodd"
});

function SvgIconPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTE3IDEyLjVjLTEuMiAwLTIuNC0uMi0zLjYtLjYtLjMtLjEtLjcgMC0xIC4ybC0yLjIgMi4yYy0yLjgtMS40LTUuMS0zLjgtNi42LTYuNmwyLjItMi4yYy4zLS4zLjQtLjcuMi0xLS4zLTEuMS0uNS0yLjMtLjUtMy41IDAtLjYtLjQtMS0xLTFIMUMuNCAwIDAgLjQgMCAxYzAgOS40IDcuNiAxNyAxNyAxNyAuNiAwIDEtLjQgMS0xdi0zLjVjMC0uNi0uNC0xLTEtMXpNMTYgOWgyYzAtNS00LTktOS05djJjMy45IDAgNyAzLjEgNyA3em0tNCAwaDJjMC0yLjgtMi4yLTUtNS01djJjMS43IDAgMyAxLjMgMyAzeiIgZmlsbD0iI0ZGRiIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+";
export { SvgIconPhone as ReactComponent };